<template>
    <div>
        <!--class="grid with-grid-lines page--light is-chrome"-->
        <encabezado></encabezado>
        <breadcrum :titulo='titulo' :texto='texto'>
            <p class="text--smaller" style="color: white;" ">
                Si su equipo está fuera de garantía y desea consultar el coste del presupuesto de reparación o coste de elaboración de presupuesto puede contactar con nosotros al teléfono <b>900105114</b> o al correo electrónico <b>"sat@zeleris.com"</b>
            </p>
            <!--<p>* Este número tiene una tarificación especial pero puede consultarlo con su operador de telefonia</p>
        <p class="text--smaller">Horario de lunes a viernes de 09:00h a 19:00h</p>-->
        </breadcrum>
        <div style="padding-left:10%">
            <textos-index></textos-index>
            <formulario></formulario>
            <boton-enviar></boton-enviar>
        </div>
        <pie></pie>
    </div>
</template>

<script>
    import encabezado from '@/components/newEncabezado'
    import breadcrum from '@/components/breadcrum'
    import textosIndex from '@/components/textosIndex'
    import formulario from '@/components/formulario'
    import botonEnviar from '@/components/enviarOrden'
    import pie from '@/components/newPie'

    export default {
        name: 'particularSR',
        components: {
            encabezado,
            breadcrum,
            textosIndex,
            formulario,
            botonEnviar,
            pie
        },
        data: () => ({
            titulo: "Posventa",
            texto: '¿Tu dispositivo está dañado? Danos tus datos y enviaremos a alguien a recogerlo, lo repararemos y te lo devolveremos.'
        }),
        created() {
            this.$bus.getCodigosPostales()
        }
    }
</script>